<template>
    <div class="mx-auto my-12 max-w-4xl">
        <div
            class="mx-4 flex max-w-screen-lg flex-col items-center justify-center gap-8 bg-gray-900 px-24 py-8 text-white"
        >
            <div
                class="text-center text-[24px] font-semibold tracking-tight md:text-[36px]"
            >
                Pass your exam —
                <span class="handwritten-underline-auto">guaranteed</span>
            </div>
            <div class="text-center">
                Here's the deal - we're so confident in our platform that if you
                don't pass your exam, we'll extend your membership for free
                until you do.
            </div>
            <div>
                <Link :href="route('frontend.pricing')" class="btn btn-primary"
                    >Get started for $39/month
                </Link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FrontendPassGuarantee",
};
</script>
